module.exports = "https://web-phone.apps.phone.com/static/media/call-waiting-sound.17fcdaf0.mp3";